import { useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="text-center max-w-md">
        <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground mb-6">404</p>
        <h1 className="font-serif text-4xl md:text-5xl text-foreground mb-6">
          {t.navHome === 'Startseite' ? 'Seite nicht gefunden' : 'Page Not Found'}
        </h1>
        <div className="w-12 h-px bg-gold mx-auto mb-8" aria-hidden="true" />
        <p className="text-muted-foreground mb-10 leading-relaxed">
          {t.navHome === 'Startseite'
            ? 'Die angeforderte Seite existiert nicht oder wurde verschoben.'
            : 'The page you are looking for does not exist or has been moved.'}
        </p>
        <Link
          to="/"
          className="inline-block px-10 py-4 border border-foreground/20 text-xs tracking-[0.25em] uppercase font-sans text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
        >
          {t.navHome}
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
